import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import {
  ProductionDeviationResponse,
  productionDeviationSchema,
} from "features/CenterContent/RoleContent/ProductionDeviation/types/responseSchema";
import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";

export const productionDeviationQueryKey = (countryCode: string) => [
  "productionDeviation",
  countryCode,
];

export const useProductionDeviation = () => {
  const countryCode = useCountryCodeForDropsRole();

  const productionDeviations = useQuery({
    queryKey: productionDeviationQueryKey(countryCode),
    staleTime: 0,
    queryFn: ({ signal }) =>
      axiosClient
        .get<ProductionDeviationResponse[]>(
          `${getBackendUrl()}/production-deviation/visible/${countryCode}`,
          {
            signal,
          },
        )
        .then((res) =>
          res.data.map((it) => productionDeviationSchema.parse(it)),
        ),
  });

  return productionDeviations;
};
